import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import { marketingData } from "../../../assets/data/data";
import MarketingCard from "../../../components/Content/MarketingCard";
import CalculatorModal from "../../../components/Modals/CalculatorModal";
import SuccessChecklistModal from "../../../components/Modals/SuccessChecklistModal";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  SNACKBAR_SUCCESS_MESSAGE,
} from "./Marketing.constants";
import { RootBox, StyledBackdrop, GridContainer } from "./Marketing.styles";

const Marketing = () => {
  const [openCalculator, setOpenCalculator] = useState(false);
  const [checklistModalState, setChecklistModalState] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handleCalculator = () => setOpenCalculator((prev) => !prev);

  const handleCardClick = (item) => () => {
    if (item.modal) {
      setChecklistModalState(true);
    } else if (item.link) {
      window.open(item.link, "_blank");
    }
  };

  return (
    <RootBox>
      <StyledBackdrop open={loading}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text={SNACKBAR_SUCCESS_MESSAGE}
      />
      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        noIcon
        videoUrl={VIDEO_URL}
      />

      <GridContainer container spacing={2}>
        {marketingData.map((item) => (
          <MarketingCard
            key={item.id}
            item={item}
            onClickCalculator={handleCalculator}
            onClick={handleCardClick(item)}
            link={item.link}
          />
        ))}
      </GridContainer>

      <CalculatorModal
        open={openCalculator}
        handleClose={handleCalculator}
        setLoading={setLoading}
        setSuccess={setSuccess}
        setErrorState={setErrorState}
      />
      <SuccessChecklistModal
        open={checklistModalState}
        handleClose={() => setChecklistModalState(false)}
        setLoading={setLoading}
        setSuccess={setSuccess}
        setErrorState={setErrorState}
      />
    </RootBox>
  );
};

export default Marketing;
